import { Container } from "@/components/Container"
import { DepositType, useTopUp } from "@usher/pe-client-front-end-lib"
import { lazy, Suspense } from "react"
import { FormattedMessage } from "react-intl"
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom"
import { STEPS } from "./constants"
import { TopUpSteps } from "./sections/Steps"
const ByCrypto = lazy(async () => await import("./sections/ByCrypto"))
const Confirmation = lazy(async () => await import("./sections/Confirmation"))
const Instruction = lazy(async () => await import("./sections/Instruction"))
const Status = lazy(async () => await import("./sections/Status"))
const TransactionHash = lazy(async () => await import("./sections/TransactionHash"))

interface Props {
  depositType?: DepositType
}

export const Topup = ({ depositType }: Props) => {
  const { path } = useRouteMatch()
  const isIban = depositType === DepositType.IBAN
  const { isAuthorized, isInitialized, currentStep } = useTopUp(STEPS(depositType))
  if (!isInitialized) return null
  if (!isAuthorized) return <Redirect to="/login" />

  return (
    <Container>
      <TopUpSteps step={currentStep} title={isIban ? <FormattedMessage id="top-up-iban" /> : void 0} depositType={depositType} />
      <Suspense>
        <Switch>
          <Route exact path={`${path}`} render={() => <Redirect to={`${path}/by-crypto`} />} />
          <Route exact path={`${path}/by-crypto`}>
            <ByCrypto depositType={depositType} />
          </Route>
          <Route exact path={`${path}/confirmation`}>
            <Confirmation depositType={depositType} />
          </Route>
          <Route exact path={`${path}/instruction`}>
            <Instruction depositType={depositType} />
          </Route>
          <Route path={`${path}/instruction/hash/:token`} component={TransactionHash} />
          <Route path={`${path}/status/:token`}>
            <Status depositType={depositType} />
          </Route>
        </Switch>
      </Suspense>
    </Container>
  )
}
